export default __webpack_public_path__ + "app/components/tables/administration/accounts/reactAdministrationAccountsTable.html";